//* 계좌환불(계좌이체) 요청 목록 페이지 — 면세계산서와 페이지 분리 운영 (공용 컨텐츠: OrderRequestListContent)
import { FC } from 'react';

import { OrderRequestListContent } from '@service/seller/containers/OrderRequestList/OrderRequestListContent';

import { useSellerTopNavHook } from '../hooks/useSellerTopNavHook';

export const SellerManualRefundRequestPage: FC = function SellerManualRefundRequestPage() {
  useSellerTopNavHook('계좌환불요청');
  return (
    <div className="mx-auto max-w-6xl px-4 pb-8 sm:px-6 lg:px-8">
      <div className="mt-8">
        <OrderRequestListContent kind="manualRefund" />
      </div>
    </div>
  );
};
